module.exports = __webpack_public_path__ + "img/oval_blue_with_white_interior_mod.86600f60.png";